export default __webpack_public_path__ + "static/media/teller-top2.68da649d.png";